<template>
  <div class="width-10 combo-box-holder" :class="{'open': dropdownVisible}">
    <!-- Desktop combo-box -->
    <div
      class="select-box-holder combo-box o-combobox"
      v-if="!isMobile"
      v-has-value="value"
      v-validate="errors"
      ref="comboBox"
    >
      <div class="input-box">
        <div class="input-holder">
          <input
            class="o-combobox__input"
            type="text"
            ref="comboInput"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @keyup.enter.prevent="select(focusIndex)"
            @focus="dropdownVisible = true"
            v-on:keyup.8="onBackspace"
            @keydown.tab="onTab"
            @keydown.down.prevent="focusNext()"
            @keydown.up.prevent="focusPrev()"
            @blur="onBlur"
            :autocomplete="`off-${new Date().getTime()}`"
          />

          <i
            class="icon icon--dropdown"
            ref="icon"
          ></i>

          <ul
            class="o-date-list option-list"
            :class="{'hide-dropdown': !dropdownVisible}"
            v-if="filteredOptions.length > 0"
            ref="ul"
          >
            <li
              v-for="(option, index) in filteredOptions"
              :key="index + 1"
              @click="select(index)"
              @mouseenter="focusIndex = index"
              @mouseleave="focusIndex = -1"
              :class="{'o-date-list__item--active': index == focusIndex, 'selected': index === selectedIndex, 'disabled': option.disable}"
              class="o-date-list__item"
            >
              {{ option.label }}
            </li>
          </ul>

          <slot></slot>
        </div>

        <!-- Desktop tooltip -->
        <div v-if="!isTooltip" class="tooltip">
          <i class="icon icon--status-ok"></i>
        </div>
        <tooltip v-if="isTooltip">
          <slot name="tooltip"></slot>
        </tooltip>
      </div>

      <!-- Desktop validations -->
      <div class="validation-output">
        <slot name="validations"></slot>
      </div>
    </div>

    <!-- Mobile combo-box -->
    <mobile-combo-box
      v-if="isMobile"
      :options="options"
      :allow-filter="allowFilter"
      :errors="errors"
      :value="value"
      @select="$emit('select', $event)"
      @input="$emit('input', $event)"
    >
      <!-- Mobile label -->
      <slot></slot>

      <!-- Mobile validations -->
      <template slot="validations">
        <slot name="validations"></slot>
      </template>

      <!-- Mobile tooltip -->
      <template slot="tooltip" v-if="isTooltip">
        <slot name="tooltip"></slot>
      </template>
    </mobile-combo-box>
  </div>
</template>

<script>
import MobileComboBox from './MobileComboBox.vue';
import Tooltip from 'union_components'

export default {
  name: 'ComboBox',
  props: {
    options: {
      required: false,
      type: Array,
      default: () => [],
    },
    value: {
      required: true,
    },
    allowFilter: {
      required: false,
      type: Boolean,
      default: () => true,
    },
    errors: {
      required: false,
      type: Array,
      default: () => [],
    },
  },
  components: {
    MobileComboBox,
    Tooltip,
  },
  data() {
    return {
      dropdownVisible: false,
      focusIndex: -1,
    };
  },
  computed: {
    /*
    * Ak property allowFilter sa rovna false computed nebude filtrovat
    * options a vrati cely array.
    * */
    filteredOptions() {
      if (!this.allowFilter) return this.options;
      return this.options.filter((option) => option.label.toLowerCase().indexOf(this.value.toLowerCase()) !== -1);
    },
    /*
    * Index na zaklade ktoreho sa do polozky zoznamu prida css trieda .selected
    * */
    selectedIndex() {
      if (this.value !== undefined) return this.filteredOptions.findIndex((option) => option.label === this.value.label);
      return undefined;
    },
    /*
    * Vrati true ak je to mobilne zariadenie Android|iOS|Windows Phone
    * */
    isMobile() {
      return [
        /Android/i, /webOS/i, /iPhone/i, /iPad/i,
        /iPod/i, /BlackBerry/i, /Windows Phone/i,
      ].some((toMatchItem) => navigator.userAgent.match(toMatchItem));
    },
    /*
    * Vrati true ak datum ma tooltip
    * */
    isTooltip() {
      return !!this.$slots.tooltip;
    },
  },
  methods: {
    /*
    * Selectnutie moznosti v zozname
    * */
    select(index) {
      // Ak je focusnuta nejaka moznost a zaroven a dlzka vyfiltrovanych moznosti je > 0
      if (index !== -1 && this.filteredOptions.length > 0) {
        // Moznost nie je disablovana
        if (!this.filteredOptions[index].disable) this.$emit('select', this.filteredOptions[index]);
      }
      // Skry dropdown a blur sa z inputu
      this.dropdownVisible = false;
      this.$refs.comboInput.blur();
    },
    /*
    * Prepne focus na dalsiu polozku v zozname
    * */
    focusNext() {
      if (this.filteredOptions.length !== this.focusIndex + 1) this.focusIndex += 1;
    },
    /*
    * Prepne focus na predchadzajucu polozku v zozname
    * */
    focusPrev() {
      if (this.focusIndex !== 0) this.focusIndex -= 1;
    },
    /*
    * Po stlaceni tab-u skryje zoznam
    * */
    onTab() {
      this.dropdownVisible = false;
    },
    /*
    * Po stlaceni backspace zobrazi zoznam
    * */
    onBackspace() {
      this.dropdownVisible = true;
    },
    /*
    * Po blurnuti z pola skryje zoznam
    * */
    onBlur() {
      setTimeout(() => {
        this.dropdownVisible = false;
      }, 200);
    },
  },
  watch: {
    /*
    * Ak sa zmenia moznosti nastav focus na prvu polozku v zozname
    * */
    filteredOptions() {
      this.focusIndex = 0;
    },
  },
};
</script>

<style scoped>
  ul { top: 100%; }
  .combo-box-holder.open { z-index: 1000; }
  .combo-box-holder.open .option-list { z-index: 2000; }
</style>
